import { StatusResult } from '../shared/enum/StatusResult';

export interface UploadStilingueResultProps {
    message: string,
    title: string,
    property: string,
    status: StatusResult
}

export const uploadStilingueResultPropsInitial: UploadStilingueResultProps = {
    message: '',
    title: '',
    property: '',
    status: StatusResult.DEFAULT
};